const state = {
    RoleItems: {
        data: [],
        total: 0,
    },
    AccessModuleItems: {
        data: [],
        total: 0,
    },
    Loadings: {
        list: true,
        save: false,
        create: false
    },

};

const getters = {
    RoleItems: (state) => state.RoleItems,
    AccessModuleItems: (state) => state.AccessModuleItems,
    Loadings: (state) => state.Loadings,
};

const actions = {
    //Items
    async getAccessModuleItems({ commit }, params) {
        let page = params.page || 1;
        let limit = params.limit || -1;
        let filter = params.filter || null;
        let group_session = params.group_session || 1;
        let scope = params.scope || null;
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.get(`api/authorisable-modules`, {
                    params: {
                        page: page,
                        limit: limit,
                        filter: filter,
                        group_session: group_session,
                        scope: scope
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setAccessModuleItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getRoleItems({ commit }, params) {
        let page = params.page || 1;
        let limit = params.limit || -1;
        let filter = params.filter || null;
        let request_params = {
            page: page,
            limit: limit,
            filter: filter,
        }
        if(params.allow_roles) {
            request_params.allow_roles = params.allow_roles
        }
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.get(`api/roles`, {
                    params: request_params
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    commit('setRoleItems', response.data.data);
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createRoleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "create", val: true });
            global.axios.post(`api/roles`, params)
                .then(response => {
                    commit('setLoadings', { key: "create", val: false });
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "create", val: false });
                    reject(error);
                });
        });
    },
    async updateRoleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "create", val: true });
            let id = params.id;
            let data = { name: params.name };
            global.axios.put(`api/roles/${id}`, data)
                .then(response => {
                    commit('setLoadings', { key: "create", val: false });
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "create", val: false });
                    reject(error);
                });
        });
    },
    async deleteRoleItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            commit('setLoadings', { key: "list", val: true });
            global.axios.delete(`api/roles`, {
                    data: {
                        ids: params
                    }
                })
                .then(response => {
                    commit('setLoadings', { key: "list", val: false });
                    resolve(response.data.data);
                })
                .catch(error => {
                    commit('setLoadings', { key: "list", val: false });
                    reject(error);
                });
        });
    },
    async cloneItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/roles/clone`, { ids: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    async getRolePermissions({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/role-permission`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateRolePermission({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/role-permission`, params)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    async exportData({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/roles/export`, { responseType: 'blob' })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },


};

const mutations = {
    setRoleItems(state, data) {
        state.RoleItems.data = data.items;
        state.RoleItems.total = data.total;
    },
    setAccessModuleItems(state, data) {
        state.AccessModuleItems.data = data.items;
        state.AccessModuleItems.total = data.total;
    },
    setLoadings(state, data) {
        state.Loadings[data.key] = data.val;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}